import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import leftArrow from './left-arrow.svg';
import successHeaderPaid from './success-header-free-bg.svg';
import smartDietPlanImg from './smart-diet-plan.svg';
import RequestCallBack from '../../../component/RequestCallBack';

const FreeHeader = () => {

    const navigate = useNavigate();

    return(
        <>
        <div className='position-relative'>
            <img src={leftArrow} alt="" className='diet-plan-left-arrow' onClick={() => navigate(-1)} />
            <img src={successHeaderPaid} alt="" className='w-100' />
            <div className='diet-plan-free-header-title absolute-Center text-center'>
                <h2 className='mb-0'>Meet the smart</h2>
                <h5 className='mb-0'>AI Diet plan</h5>
            </div>
        </div>
        <div className='diet-plan-free-card position-relative'>
            <p>1 month smart diet plan</p>
            <h3>Free <span className='actual-price text-decoration-line-through'>₹599</span><span className='limited-time float-end'>limited time only</span></h3>
        </div>
        <h3 className='diet-plan-free-title mt-4 pt-2 mb-4'>Quick start your journey <br/>to <span className='yellow'>better health</span></h3>
        <Container>
            <Row>
                <Col xs="2" className='text-end'><img src={smartDietPlanImg} alt="" className='feature-icon-img' /></Col>
                <Col xs="10" className='ps-2'>
                    <h4 className='feature-title mb-1'>Smart diet plan</h4>
                    <p className='feature-description'>We base our diet plans on your preferences and goals with limited options</p>
                </Col>
            </Row>
        </Container>
        <h3 className='diet-plan-free-title mb-4'>Fill out this short assessment for your <br /><span className='yellow'>AI diet plan</span></h3>
        </>
    );
}

export default FreeHeader;